import { IApplicationState } from '../../types/redux';

export const selectExperiments = (state: IApplicationState) => state.abUseExperiments;
